import { useQuery } from '@tanstack/react-query';
import { getRestaurant } from '../../../store/Restaurant/api';

export const useGetStore = ({ slug }) => {
    return useQuery(['store', slug], () => getRestaurant(slug));
}
